import api from '@/api'
import * as types from './types'

export default {
  setStandardOpeningHours({
    commit
  }, openingHours) {
    commit(types.SET_STANDARD_OPENING_HOURS, openingHours)
  },
  setHolidayOpeningHours({
    commit
  }, openingHours) {
    commit(types.SET_HOLIDAY_OPENING_HOURS, openingHours)
  },
  async getStandardOpeningHours({ commit, dispatch }, tenantId) {
    return new Promise((resolve, reject) => {
      api.getStandardOpeningHours(tenantId)
        .then(response => {
          commit(types.SET_STANDARD_OPENING_HOURS, response.data)
          resolve(response)
        })
    })
  },
  async getHolidayOpeningHours({ commit, dispatch }, tenantId) {
    return new Promise((resolve, reject) => {
      api.getHolidayOpeningHours(tenantId)
        .then(response => {
          commit(types.SET_HOLIDAY_OPENING_HOURS, response.data)
          resolve(response)
        })
    })
  },
  async getStandardOpeningHoursForList({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.getStandardOpeningHoursForList()
        .then(response => {
          commit(types.SET_STANDARD_OPENING_HOURS, response.data)
          resolve(response)
        })
    })
  },
  async getTenantDetails({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.getTenantDetails()
        .then(response => {
          commit(types.SET_TENANT_DETAILS, response.data)
          resolve(response)
        })
    })
  },
  setSelectedTenant({ commit, state }, tenantID) {
    let tenantDetails = null

    // Safely parse tenantDetails if it's a string
    try {
      tenantDetails = typeof state.tenantDetails === 'string'
        ? JSON.parse(state.tenantDetails)
        : state.tenantDetails
    } catch (error) {
      console.error('Invalid JSON structure:', error)
      return
    }

    if (tenantDetails && Array.isArray(tenantDetails.Items)) {
      const tenant = tenantDetails.Items.find(t => t.ID === tenantID)

      if (tenant) {
        commit(types.SET_SELECTED_TENANT, tenant)
      }
    }
  },
  async updateTenantSupportEmail({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.updateTenantSupportEmail(data)
        .then(response => {
          commit(types.SET_TENANT_DETAILS, response.data)
          resolve(response)
        })
    })
  },
  async updateStandardOpeningHours({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.updateStandardOpeningHours(data)
        .then(response => {
          commit(types.SET_STANDARD_OPENING_HOURS, response.data)
          resolve(response)
        })
    })
  },
  async updateHolidayOpeningHours({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.updateHolidayOpeningHours(data)
        .then(response => {
          commit(types.SET_HOLIDAY_OPENING_HOURS, response.data)
          resolve(response)
        })
    })
  },
  async insertHolidayOpeningHours({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.insertHolidayOpeningHours(data)
        .then(response => {
          commit(types.SET_HOLIDAY_OPENING_HOURS, response.data)
          resolve(response)
        })
    })
  },
  async deleteHolidaySchedule({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.deleteHolidaySchedule(data)
        .then(response => {
          commit(types.SET_HOLIDAY_OPENING_HOURS, response.data)
          resolve(response)
        })
    })
  },
  async getOutOfHoursAuditLog({commit, dispatch}, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getOutOfHoursAuditLog(searchOptions)
        .then(response => {
          commit(types.SET_OUT_OF_HOURS_AUDIT_LOG, response.data)
          resolve(response)
        })
    })
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/openinghours/actions.js